export default class Modal
{
    constructor(selector) {
        this.locked = 0;
        this.modalElement = document.querySelector(selector);
        
        this.modalElement.querySelector('.closeRef').addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });
        
        this.modalElement.querySelector('.referenceBg').addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });
    }

    start() {
        if (!this.locked) {
            this.modalElement.classList.add('showRef');
            document.querySelector('body').classList.add('overflowed');
        }
    }

    close() {
        this.modalElement.classList.remove('showRef');
        document.querySelector('body').classList.remove('overflowed');
    }

    insertContent(content) {
        this.modalElement.querySelector('.emp-modal__content').innerHTML = content;
    }
    
    lock(){
        this.locked = 1;
    }
}


